<template>
    <v-touch @swiperight="swiperright" class="wrapper">
        <div class="selectContract">
            <van-nav-bar
                title="选择合同信息"
                left-text="价格变更"
                left-arrow
                @click-left="onClickLeft"
            >
            </van-nav-bar>
            <van-search v-model="Keywords" placeholder="请输入搜索信息" @change="search"></van-search>
            <section>
                <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
                    <van-list
                        v-model="isUpLoading"
                        :finished="finished"
                        finished-text="没有更多了!"
                        @load="onLoad"
                    >
                        <ul class="list">
                            <template v-for="(item,index) in listData">
                                <li :key="index" @click="confirmSelection(item)">
                                    <div class="engineeringInfo">
                                        <h4 class="engineeringInfo_header">
                                            <span class="headerName">合同编号：{{ item.contract_no }}</span>
                                        </h4>
                                        <div class="engineeringInfo_content">
                                            <p>
                                                <img src="@/assets/images/icons/icon_gy_3.png" alt="">
                                                <span>合同名称：{{ item.contract_name }}</span>
                                            </p>
                                            <p>
                                                <img src="@/assets/images/icons/icon_gy_7.png" alt="">
                                                <span>签订日期：{{ item.signing_date }}</span>
                                            </p>
                                        </div>
                                    </div>
                                </li>
                            </template>
                        </ul>
                    </van-list>
                </van-pull-refresh>
            </section>
        </div>
    </v-touch>
</template>

<script>
export default {
    // 选择合同
    name: 'select-contract',
    components: {},
    props: {},
    data() {
        return {
            // 下拉login状态
            isLoading: false,
            // 上拉login状态
            isUpLoading: false,
            // 是否加载完数据
            finished: false,
            // 当前页码
            pageIndex: 0,
            // 列表数据
            listData: [],
            // 查询条件
            Keywords: '',
        };
    },
    computed: {},
    watch: {},
    created() {},
    mounted() {},
    destroyed() {},
    methods: {
        // 返回上一页
        onClickLeft() {
            this.$router.isBack = 1;
            this.$router.go(-1);
        },
        // 右划回退
        swiperright() {
            this.$router.isBack = 1;
            this.$router.go(-1);
        },
        // 下拉刷新
        onRefresh() {
            this.pageIndex = 1;
            this.listData = [];
            this.finished = false;
            this. isLoading = true;
            this.isUpLoading = false;
            this.getListData();
        },
        // 上拉加载更多
        onLoad() {
            this. isLoading = false;
            this.isUpLoading = true;
            this.pageIndex++;
            this.getListData();
        },
        // 获取列表数据
        getListData() {
            this.$axios
                .get('/interfaceApi/Procurement/material/price/adjust/getcontractpage?pageindex='
                    + `${this.pageIndex}&pagesize=4&searchkey=${this.Keywords}`)
                .then(res => {
                    if (res.rows.length > 0) {
                        this.listData.push(...res.rows);
                        this.finished = false;
                    } else {
                        this.finished = true;
                    }
                    this. isLoading = false;
                    this.isUpLoading = false;
                })
                .catch(error => {
                    this. isLoading = false;
                    this.isUpLoading = false;
                    this.$toast({ message: error.ErrorCode.Message });
                });
        },
        // 搜索
        search() {
            this.pageIndex = 1;
            this.listData = [];
            this.finished = false;
            this. isLoading = true;
            this.isUpLoading = false;
            this.getListData();
        },
        // 确认选择合同
        confirmSelection(item) {
            this.$router.isBack = 1;
            this.$router.replace({
                name: 'newPriceAdjustment',
                params: {
                    selectContractData: item,
                },
            });
        },
    },
};
</script>
<style lang="stylus">
.selectContract
    height 100%
    section
        height calc(100% - 85rpx)
        .van-pull-refresh
            height 100%
            overflow: scroll;
            -webkit-overflow-scrolling: touch;
            .list
                height 100%
                overflow-y auto
                background #F0F0F0
                padding 0 15rpx
                padding-bottom 0
                li
                    width 100%
                    background #fff
                    overflow hidden
                    margin-bottom 15rpx
                    position relative
                    &:first-child
                        margin-top 15rpx
                    .engineeringInfo
                        position relative
                        padding 15rpx
                        padding-bottom 0
                        img,span
                            float left
                            height 16rpx
                            line-height 16rpx
                        img
                            width 16rpx
                            margin-right 12rpx
                        h4,p
                            overflow hidden
                        h4
                            margin-bottom 14rpx
                            width 100%
                            span
                                display inline-block
                                width 100%
                                font-size 18rpx
                                height 20rpx
                                line-height 20rpx
                                color #061F3E
                                overflow hidden
                                text-overflow ellipsis
                                white-space nowrap
                                &:before
                                    font-size 20rpx
                                    margin-right 10rpx
                                    color #5588F1
                        p
                            margin-bottom 14rpx
                            span
                                display inline-block
                                width calc(100% - 40rpx)
                                overflow hidden
                                text-overflow ellipsis
                                white-space nowrap
                                font-size 14rpx
                                color #666666
</style>